import { useState } from 'react';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type TaskCloseActionPropsType = {
  onClose: () => void;
};

export const TaskCloseAction: React.FC<TaskCloseActionPropsType> = ({
  onClose,
}) => {
  const { t } = useTranslation('tasks');
  const [isArmed, setIsArmed] = useState(false);

  const label = isArmed
    ? t('ACTIONS.CONFIRM_CLOSE')
    : t('ACTIONS.CLOSE');

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();

    if (!isArmed) {
      setIsArmed(true);
      return;
    }

    onClose();
  };

  return (
    <Tooltip label={label}>
      <ActionIcon
        size="sm"
        color={isArmed ? 'green' : 'gray'}
        variant={isArmed ? 'filled' : 'subtle'}
        onClick={handleClick}
        aria-label={label}
      >
        <FontAwesomeIcon
          icon={faCheck}
          size="sm"
          color="var(--mantine-color-text-4)"
        />
      </ActionIcon>
    </Tooltip>
  );
};
